import { useAsyncData, useRoute } from '#imports'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

import { useMasterPP } from '~/scopes/product-core/composables/useMasterPP/useMasterPP'

export function useFetchSiblings() {
  const $httpFetch = useHttpFetch()
  const route = useRoute()
  const { isMasterPPUrl } = useMasterPP()
  const locale = useI18nLocale()

  return useAsyncData(
    getAsyncDataKey('pp_siblings', { slug: route.params.slug || 'no-slug' }),
    async () => {
      if (!isMasterPPUrl.value) {
        return []
      }

      const data = await $httpFetch(
        '/product-page/parent-products/siblings/:slug',
        {
          pathParams: { slug: `${route.params.slug}` },
          timeout: 500,
        },
      )

      return (data || []).map(({ slug, title }) => ({
        title,
        relativeLink: `/${toBcp47Locale(locale)}/p/${slug}`,
      }))
    },
    {
      dedupe: 'defer',
      default: () => [],
      watch: [() => route.params.slug],
    },
  )
}
